import {PaySuccessDialog, PayRetainDialog, PaymentDialog} from "@/components/payment/index.js"

import {memberList} from "@/components/payment/module";
import { info } from './module'
import {getPayCode, getPayResult} from "@/api/pay";
import {fnLogin, fnPay} from "@/fn";
import PayModal from '~/components/pay'
import {BUSINESS_VIP_INFO, BUSINESS_VIP_NAME, PERSON_VIP_INFO, PERSON_VIP_NAME} from '@/constant/VIP'
import {tagStat} from "@/api/stat";
import {PAY} from "@/constant/PATH";

/* 支付弹框公共部分抽离 */
let memberExtend = {
  components: {
    PaymentDialog,
    PaySuccessDialog,
    PayRetainDialog,
    PayModal
  },
  data() {
    return {
      BUSINESS_VIP_INFO,PERSON_VIP_INFO,
      memberList,
      PERSON_VIP_NAME,
      BUSINESS_VIP_NAME,
      info,
      timerList: [],
      timer: null,
      memberIndex: 0,
      payment: {
        isShowWft: '',
        zfbUrl: '',
        wxUrl: '',
      },
      vipFullName: '',
      memberType: '',
      vip: {
        vipId: 1,
        mealId: 1
      },
      dialogType: 1,  // 弹框类型 1默认vip 2图片包

    }
  },
  methods: {
    /**
     * 会员充值
     * Object vo  充值套餐对象 { id }
     * String idx 设置套餐选中索引 0 1 商用会员 2个人会员
     * @returns {Promise<boolean>}
     */
    async buy(vo) {
      await this.updateChoiceVipFullName(vo);
      if (fnLogin.checkLogin()) {
        // this.toggleVip({vipId: vo.PARENT_ID, mealId: vo.ID})
        await fnPay.getPayCode(vo.ID).then(res => {
          let {payment, ali_pay, wechat_pay} = res;
          this.payment = payment
          this.getPayResult(ali_pay.order_no)
          this.getPayResult(wechat_pay.order_no)
          // 显示弹框
          this.$refs.PaymentDialog.isShow = true;
        })
      } else {
        this.$store.commit("user/SET_IS_SHOW_LOGIN", true);
      }
    },
    /* 更新选中套餐全名，用于购买成功显示 */
    updateChoiceVipFullName(vo){
      let findVipInfo = fnPay.getCurrentVipInfo(vo.ID)
      if (!!findVipInfo){
        this.vipFullName = findVipInfo.FULL_NAME
      }
      console.log(this.vipFullName)
    },
    getPayResult(order_no) {
      this.timer = setInterval(() => {
        fnPay.getPayResult(order_no).then(res => {
          if (res.status === 1) {
            this.$refs.PaySuccessDialog.isShow = true;
            this.$refs.PaymentDialog.isShow = false;
            clearInterval(this.timer);// 满足条件时 停止计时
            this.timerList.forEach((item, index) => {
              clearInterval(item);
            })
            this.timerList = [];
            this.timer = 0;
          }
        })
      }, 2000)
      this.timerList.push(this.timer)
    },
    closePayDialog() {
      // 挽留一下
      this.$refs.PaymentDialog.isShow = false;
      this.$refs.PayRetainDialog.isShow = true;
    },
    /* 挽留失败 */
    PayRetainCancel() {
      this.$refs.PayRetainDialog.isShow = false;
      this.$refs.PaymentDialog.isShow = false;
      this.clearTimer();
    },
    /* 挽留成功 */
    PayRetainConfirm() {
      this.$refs.PaymentDialog.isShow = true;
    },
    clearTimer() {
      if (this.timer) {
        this.timerList.forEach((item, index) => {
          clearInterval(item);
        })
        this.timerList = [];
        this.timer = 0;
      }
    },
    toggleVip(vo= BUSINESS_VIP_INFO) {
      this.dialogType = 1;
      let {ID, PARENT_ID} = vo;
      this.vip = {
        vipId: PARENT_ID,
        mealId: ID
      }

      this.clearTimer();
      this.buy(vo);
    },

    navigatorToPay(id=2){
      let path = `${PAY}/${id}`
      window.open(path, '_blank')

      /*this.$router.push({
        path:PAY
      });*/
    }
  }
}


export default memberExtend
